import { noop, isFunction, isEmpty } from 'lodash/fp';
import styled from 'styled-components';
import { Component, ReactNode } from 'react';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Loader, OptimusPlainLink } from '@mews-commander/ui';
import { PieChartData } from '../types';
import { SIZE } from './constants';
import { PieChart } from '.';

const ChartWrapper = styled.div<{ clickable?: boolean }>`
    ${(props) =>
        props.clickable &&
        `
        cursor: pointer;
        display: inline;
    `}
`;

const PieChartPlaceholder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${SIZE}px;
    height: ${SIZE}px;
`;

export interface ConnectedPieChartProps {
    showLoader?: boolean;
    onMount?: () => void;
    onUnmount?: () => void;
    onClick?: () => void;
    data?: {
        color?: string;
        value: number;
        label: ReactNode;
        valueLabel?: string;
    }[];
    showEmpty?: boolean;
    dataTestId?: string;
}

export default class ConnectedPieChart extends Component<ConnectedPieChartProps> {
    static defaultProps = {
        onMount: noop,
        onUnmount: noop,
        showEmpty: false,
    };

    componentDidMount() {
        this.props.onMount?.();
    }

    componentWillUnmount() {
        this.props.onUnmount?.();
    }

    handleClick = () => this.props.onClick && this.props.onClick();

    render() {
        const { data, onClick, showLoader, showEmpty, dataTestId } = this.props;

        let component = null;
        if (showLoader) {
            component = (
                <PieChartPlaceholder>
                    <Loader />
                </PieChartPlaceholder>
            );
        } else if (!isEmpty(data)) {
            component = (
                <ChartWrapper onClick={this.handleClick} clickable={isFunction(onClick)} data-test-id={dataTestId}>
                    <PieChart data={data as PieChartData[]} />
                </ChartWrapper>
            );
        } else if (showEmpty) {
            component = (
                <OptimusPlainLink onClick={this.handleClick} inherit>
                    <LocalizedText textKey={TextKey.NothingToBeDone} />
                </OptimusPlainLink>
            );
        }

        return component;
    }
}
